<template>
  <div id="fault">
    <van-field v-model="fault" placeholder="请输入产品" right-icon="search" @input="queryParams"/>
    <div class="category">
      <div class="categoryTitle">分类</div>
      <div class="categoryContent">
        <div class="categoryItem"  v-for="item in faultListData" :key="item.id" @click="faultReason(item)">
          <img class="img" :src="`${uploadUrl}${item.imgUrl}`" alt="" />
          <div class="imgTitle">{{ item.productName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  
  name: "fault",
  data() {
    return {
      fault: "",
      faultListData: [],
      uploadUrl:''
    };
  },
  created() {},
  mounted() {
    this.uploadUrl = apis.uploadUrl;
    this.getDataList()
  },
  methods: {
    // 获取 下拉 数据
    getDataList() {
      apis.getAllProduct().then(res => {
        if (res.code === 200) {
          this.faultListData = res.data;
        }
      });
    },
    // 故障原因
    faultReason(item) {
      this.$router.push(`/gzh/mobile/faultReason?id=${item.id}`);
    },
    // 搜索
    queryParams(value) {
      const json = {
        page: 1,
        pageSize: 500,
        productName:value
      };
      apis.productList(json).then(res => {
        if (res.code === 200) {
          this.faultListData = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #fault {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #fault {
    width: 276px * $zoom;
  }
}
#fault {
  font-size: 16px * $zoom;
  padding-top: 30px;
  ::v-deep .van-cell {
    width: 94%;
    background-color: #f7f9fa;
    border-radius: 30px;
    margin-left: 3.4%;
    &::after {
      content: "";
      width: 0;
      height: 0;
    }
  }
  .category {
    .categoryTitle {
      width: 160px;
      height: 40px;
      line-height: 40px;
      font-size: 35px;
      border-left: 10px solid #00c688;
      padding-left: 15px;
      font-weight: 600;
      color: #282B32;
      margin: 30px 20px 30px 3.4%;
    }
    .categoryContent {
      display: flex;
      flex-wrap: wrap;
      .categoryItem {
        font-size: 23px;
        width: 33.3333%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        .img {
          width: 128px;
          height: 128px;
          margin-bottom: 10px;
        }
        .imgTitle {
          width: 128px;
          text-align: center;
        }
      }
    }
  }
}
</style>
